import { initializeSharing } from "app/scripts/sharing"
import ServiceTabs from "app/scripts/service_tabs"
import TqaListTabs from "app/scripts/tqa_list_tabs"
import serviceConnectSearch from "app/scripts/service_connect_search"
import TqaSuggestion from "shared/scripts/tqa_suggestion"
import { onExpiredBFCacheLoad } from "shared/scripts/back_forward_cache_utils"
import { logCustomDatadogAction, setDatadogRumContext, sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"

import "stylesheets/service.scss"

sharedVanillaSetup()

// Matches service_gated_auth.js except no react components
document.addEventListener("DOMContentLoaded", function() {
  logCustomDatadogAction?.("service_page_viewed")
  setDatadogRumContext("key-page", "service-show")
  initializeSharing()
  serviceConnectSearch()
  ServiceTabs()
  TqaListTabs()
  TqaSuggestion()

  onExpiredBFCacheLoad("service", () => window.location.reload())

  const clampedSpans = document.querySelectorAll("span.clamped")

  clampedSpans.forEach(clampedSpan => {
    clampedSpan?.addEventListener("click", e => {
      if (e.target === clampedSpan.querySelector("a")) return

      if (clampedSpan && clampedSpan.scrollHeight > clampedSpan.clientHeight) {
        clampedSpan.classList.remove("clamped")
        clampedSpan.classList.add("expanded")
      } else if (clampedSpan.classList.contains("expanded")) {
        clampedSpan.classList.remove("expanded")
        clampedSpan.classList.add("clamped")
      }
    })
  })
}, { once: true })
